//If Entry form change return true.
function dataChanged(){
  return window.form_has_changed('knowx_entry') && window.form_has_changed('knowx_entry').length >= 1;
}

//Show modal on condition
function showModalEntryForm(element, url){

  //Check elements sending receive an <a> element
  function process_continue() {

    //If element its modal, dont have any url, then print the other modal after choice button.
    if(element !== undefined && element != ''){
      if(element.attr('href')){
        url = element.attr('href');
      }else if(element.attr('data-toggle') && element.attr('data-toggle') == 'modal'){
        $(element.attr('data-target')).modal('show');
      }
    }

    if (url !== undefined && url != ''){
      window.location = url;
    }
  }
  //Show modal on entry form change
  $('#entry_unsaved_modal').modal('show');

  //Continue button
  $('#unsaved_modal').click(function(e){
    process_continue()
  });

  //Save and continue button.
  $('#saved_modal').click(function(e){
    $('#loading').addClass('loading');
    $("#entry_unsaved_modal").modal('hide');
    $.ajax({
      type: "POST",
      url: window.location,
      data: $('#knowx_entry').serialize(),
      success: function (msg) {
        process_continue()
      },
      error: function () {
        $("#error").show();
      },
      complete: function () {
        $('#loading').removeClass('loading');
      }
    });
  });
}

export { dataChanged, showModalEntryForm };
